import React from "react";
import "./Presse.css";

import { Typography } from "@material-ui/core";

// TODO

function Presse() {
  return (
    <div className="Presse">
      <Typography variant="h1">Presse</Typography>
    </div>
  );
}

export default Presse;
